import { errors } from "./errors";

export const SAFE_HTTP_METHODS = new Set<string>(["GET", "HEAD", "OPTIONS"]);

/**
 * i18n keys that mean access/refresh session is dead — redirect to login.
 * Permission denial should come as 403 with forbidden keys, not these.
 * CSRF invalid/missing often follows expired or rotated session cookies.
 */
export const SESSION_ENDED_TRANSLATION_KEYS: ReadonlySet<string> = new Set([
  errors.auth.csrfTokenMissingOrInvalid,
  errors.auth.tokenExpiredError,
  errors.common.authenticationError,
  errors.auth.tokenRefreshAuthenticationFailure,
  errors.auth.errorWhileRefreshTokens,
]);

export const AUTH_CREDENTIAL_ATTEMPT_PATH_MARKERS = [
  "/auth/session/login-otp",
  "/auth/session/login-microsoft",
  "/auth/session/login",
  "/auth/login-params",
  "/auth/login_otp",
  "/auth/request_otp",
  "/auth/forgot-password",
  "/auth/reset-password",
  "/auth/login-microsoft",
  "/auth/login-google",
  "/auth/login-saml",
  "/auth/login",
] as const;

export const AUTH_MS_REDIRECT_FLAG = "auth_ms_login_redirect_pending";

/**
 * Query flag the OAuth consent screen sends the login page with (RYDE-7833). Every IdP entry path
 * forwards it: prompt=login for Microsoft, max_age=0 + auth_time for Google, ForceAuthn for SAML.
 */
export const FORCE_LOGIN_QUERY_PARAM = "forceLogin";
export const FORCE_LOGIN_QUERY_VALUE = "1";

/**
 * OIDC claims request sent with a forced Microsoft login. auth_time is not in a Microsoft id_token
 * unless asked for, and it is the only claim the backend can verify as proof of a fresh credential
 * entry — without it a forced re-authentication cannot satisfy a strict-tenant consent.
 */
export const MS_FORCED_LOGIN_CLAIMS_REQUEST = JSON.stringify({
  id_token: { auth_time: { essential: true } },
});
